import { TFunction } from 'i18next'

export const getLocationsTip = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:locationsTab.customLocationsEnabled.tip')

export const getRequireLocationTip = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:locationsTab.locationRequired.tip')

export const getPackageRoomTip = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:locationsTab.packageRoomLocationTip')
